import React, { useState } from "react";
import Navbar from "../layout/Navbar";
import Contact from "../assets/contact.png";
import Footer from "../layout/Footer";

const ContactUs = () => {
  const [formType, setFormType] = useState("Feedback");

  return (
    <>
      <Navbar />

      {/* Hero Section with Background Image */}
      <div
        className="relative w-full h-64 bg-cover bg-center"
        style={{ backgroundImage: `url(${Contact})` }}
      >
        <div className="absolute inset-0 bg-teal-900/60">
          <div className="container mx-auto h-full flex items-center px-4">
            <div>
              <div className="w-12 h-1 bg-teal-400 mb-3"></div>
              <h1 className="text-3xl font-bold text-white">Contact Us</h1>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="bg-gray-50 py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* Contact Form Card */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden mb-8">
              <div className="bg-teal-600 p-4">
                <h2 className="text-xl font-semibold text-white">Get in Touch</h2>
              </div>
              
              <div className="p-6">
                {/* Form Type Selection */}
                <div className="flex flex-wrap gap-4 mb-6">
                  {["Feedback"].map((type) => (
                    <button
                      key={type}
                      className={`px-4 py-2 rounded-md border ${
                        formType === type
                          ? "bg-teal-500 text-white border-teal-500"
                          : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                      }`}
                      onClick={() => setFormType(type)}
                    >
                      {type}
                    </button>
                  ))}
                </div>

                {/* Form Fields */}
                <form className="space-y-4">
                  <div>
                    <label htmlFor="name" className="block text-gray-700 mb-1">Full Name*</label>
                    <input
                      id="name"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-1 focus:ring-teal-500 focus:border-teal-500"
                      type="text"
                      placeholder="Enter your full name"
                    />
                  </div>

                  <div>
                    <label htmlFor="phone" className="block text-gray-700 mb-1">Phone Number*</label>
                    <div className="flex">
                      <div className="inline-flex items-center px-3 bg-gray-100 border border-r-0 border-gray-300 rounded-l-md text-gray-600">
                        <span>IND +91</span>
                      </div>
                      <input
                        id="phone"
                        className="flex-1 px-4 py-2 border border-gray-300 rounded-r-md focus:ring-1 focus:ring-teal-500 focus:border-teal-500"
                        type="tel"
                        placeholder="Enter mobile number"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-gray-700 mb-1">Email Address*</label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                        </svg>
                      </div>
                      <input
                        id="email"
                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:ring-1 focus:ring-teal-500 focus:border-teal-500"
                        type="email"
                        placeholder="Enter your email"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-gray-700 mb-1">Your Message*</label>
                    <textarea
                      id="message"
                      rows="4"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-1 focus:ring-teal-500 focus:border-teal-500"
                      placeholder="Your comment"
                    ></textarea>
                  </div>

                  <div className="mt-6">
                    <button className="bg-teal-600 text-white py-2 px-6 rounded-md hover:bg-teal-700 flex items-center">
                      Send
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 ml-2"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>
                </form>
              </div>
            </div>

            {/* Contact Information */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden mb-8">
              <div className="bg-teal-600 p-4">
                <h2 className="text-xl font-semibold text-white">Our Contact & Address</h2>
              </div>
              
              <div className="p-6">
                {/* Search bar */}
                <div className="mb-6">
                  <input
                    type="text"
                    placeholder="Trauma Centre (BHU-84)"
                    className="w-full max-w-xs px-4 py-2 border border-gray-300 rounded-md focus:ring-1 focus:ring-teal-500 focus:border-teal-500"
                  />
                </div>

                {/* Contact Details */}
                <div className="grid md:grid-cols-3 gap-6">
                  {/* Phone Numbers */}
                  <div>
                    <h4 className="mb-2 text-sm font-semibold">CONTACT US (24×7 AVAILABILITY)</h4>
                    <ul className="space-y-1 text-sm leading-6">
                      <li>+91 9151067160 (Control cum command Desk)</li>
                      <li>+91 9151067171 (Ayushman Bharat Office)</li>
                      <li>+91 0542-2366073, 2366092, 2366187 (Reception)</li>
                      <li>+91 0542-2366187 Extn. 604 (Office)</li>
                    </ul>
                  </div>

                  {/* Email */}
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-3">📧 Email</h3>
                    <p className="text-gray-600">osdtraumabhu@gmail.com</p>
                    <p className="text-sm text-gray-500">(General Inquiry)</p>
                  </div>

                  {/* Address */}
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-3">📍 Address</h3>
                    <p className="text-gray-600">
                      Trauma Centre, BHU Campus, Varanasi,<br />
                      Uttar Pradesh - 221005
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Google Map */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="bg-teal-600 p-4">
                <h2 className="text-xl font-semibold text-white">Find Us on Map</h2>
              </div>
              
              <iframe
                title="Trauma Centre Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.870726823482!2d83.0097344752957!3d25.276389177657774!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398e2e2fcb2be335%3A0x760ed9fd45b942a2!2sTrauma%20Centre%2C%20Banaras%20Hindu%20University%2C%20Varanasi%2C%20Uttar%20Pradesh%20221005!5e0!3m2!1sen!2sin!4v1712831531234!5m2!1sen!2sin"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ContactUs;